export default [
  {
    path: "/users",
    name: "users",
    component: () => import(
      /*webpackChunkName:'user'*/
      "@/views/user/Users.vue"),
    meta: {},
  },
  {
    path: "/roles",
    name: "roles",
    component: () => import(
      /*webpackChunkName:'user'*/
      "@/views/role/Roles.vue"),
    meta: {},
  },
  {
    path: "/user/log",
    name: "userLog",
    component: () => import(
      /*webpackChunkName:'user'*/
      "@/views/user/UserLog.vue"),
    meta: {},
  },
  // {
  //   path: "/user/2FA",
  //   name: "2FA",
  //   component: () => import(
  //     /*webpackChunkName:'user'*/
  //     "@/views/user/User2FA.vue"),
  //   meta: {},
  // },
  {
    path: "/watchlist",
    name: "Watchlist",
    component: () => import(
      /*webpackChunkName:'watchlist'*/
      "@/views/watchlist/WatchlistList.vue"),
    meta: {},
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import(
      /*webpackChunkName:'setting'*/
      "@/views/user/Setting.vue"),
    meta: {},
  },
  {
    path: "/config",
    name: "config",
    component: () => import(
      /*webpackChunkName:'config'*/
      "@/views/user/Config.vue"),
    meta: {},
  },
  {
    path: "/evidences",
    name: "evidences",
    component: () => import(
      /*webpackChunkName:'Evidences'*/
      "@/views/user/Evidences.vue"),
    meta: {},
  },
]